/*eslint-disable react/display-name*/
import React from 'react';
import loadable from '@loadable/component';

const TabsCarousel = React.memo(
  ({ onTabClick, initialTabName, tabNames, className, lang }) => {
    const Component = loadable(() => import('./TabsCarouselComponent.js'), { ssr: false });
    return (
      <Component
        onTabClick={onTabClick}
        initialTabName={initialTabName}
        tabNames={tabNames}
        className={className}
        lang={lang}
      />
    );
  },
  () => true
);

export default TabsCarousel;
